// Reducer
import { ACTION_TYPES } from './locale.actions';
import { LocaleState, initialState } from './locale.state';
import { TranslatorContext } from 'react-jhipster';

export default (state: LocaleState = initialState, action): LocaleState => {
  switch (action.type) {
    case ACTION_TYPES.SET_LOCALE: {
      const currentLocale = action.locale;
      if (state.currentLocale !== currentLocale) {
        TranslatorContext.setLocale(currentLocale);
      }
      return {
        currentLocale
      };
    }
    default:
      return state;
  }
};
